import Vue from "vue";
import Vuex from "vuex";

import auth from "@/store/modules/auth";
import dashboard from "@/store/modules/dashboard";
import feedback from "@/store/modules/feedback";
import oauth from "@/store/modules/oauth";
import profile from "@/store/modules/profile";
import subscriptions from "@/store/modules/subscriptions";
import email_confirmed from "@/store/modules/email_confirmed";
import transactions from "@/store/modules/transactions";
import whitelist from "@/store/modules/whitelist";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        dashboard,
        email_confirmed,
        feedback,
        oauth,
        profile,
        subscriptions,
        transactions,
        whitelist
    }
});
